
import {createSlice} from "@reduxjs/toolkit";

export const contractSectionFilterSlice = createSlice({
    name: 'contractSectionFilterSlc',
    initialState: {value: {
            id: 0,
            contractSectionId: null,
            parentFilterId: null,
            previousFilterId: null,
            ordinalNumber: null,
            recordLevel: null,
            accessType: null,
            filteringMethod: null,
            dataPointId: null,
            singleValue: null,
            fromValue: null,
            toValue: null,
            status: null,
            hierarchy: null,
            createdOn: null,
    createdBy: null,
    lastModifiedOn: null,
    lastModifiedBy: null,
    mockValue: null,
    contractId: null,
    dataPointName: null,
    dataType: null,
    displaySingleValue: null,
    displayFromValue: null,
    displayToValue: null,
    parentDataPointId: null,
    parentDataPointName: null,
    parentDataType: null,
    parentDisplaySingleValue: null,
    parentDisplayFromValue: null,
    parentDisplayToValue: null,
            csfDrawerState: false,
            csfDrawerMode: null,
            csfGridState: false,
            csfGridRefresh: false,
            csfCount: 0
        }},
    reducers:
{
    changeContractSectionFilter: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractSectionFilter } = contractSectionFilterSlice.actions;

export default  contractSectionFilterSlice.reducer ;


